import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  Box,
  Typography,
  Modal,
  Autocomplete,
  Checkbox,
  TextField,
  RadioGroup,
  Radio,
  FormHelperText,
  FormControl,
  FormControlLabel
} from '@mui/material';

import {
  HighlightOffOutlinedIcon,
  KeyboardArrowDownOutlinedIcon,
  CheckBoxOutlineBlankIcon,
  CheckBoxIcon,
  PagesOutlinedIcon
} from '../../constants/images';

import { EMAIL_FIELDS_BLOCKS, EMAIL_TEMPLATE_DATA } from './data/emailConstants';

import { ModalWrapperNormal } from '../customComponent/box';
import { CustomFormLabel } from '../customComponent/form';

import ModalHeader from '../pop/ModalHeader';
import ModalFooter from '../pop/ModalFooter';

import * as basicConstants from '../../constants/basic';
import theme from '../../theme';


const EmailTemplateModal = (props) => {
  const {
    media,
    emailMediaData,
    modalType,
    currentData,
    handleChangeEmailTemplateMetric,
    handleRemainbudget,
    handleCancel,
    handleSubmit,
    handleCloseModal,
    optionalFields,
    requiredMetricsFields,
    emailRemainbudget,
    changeRemainbudget,
    filterEmailTemplateData,
    emailTemplateDitto,
    changeEmailTemplateDitto
  } = props;

  const intl = useIntl();
  const [currentSelectedMetric, setCurrentSelectedMetric] = useState({});
  const formatMedia = media.toLowerCase();

  const allMetricsFields = requiredMetricsFields ? (requiredMetricsFields.concat(optionalFields)) : optionalFields;
  const optionalFieldsWithOutCat = _.flatMap(allMetricsFields, el => el.child);
  const currentTemplateType = EMAIL_TEMPLATE_DATA.filter(item => item.name === modalType && item.media === media)[0];
  const currentBlocks = EMAIL_FIELDS_BLOCKS.filter(el => el.media === media);

  const getSelectedFields = (current) => {
    let temp = { ...current };

    Object.keys(current).forEach(el => {
      if (el !== 'type') {
        const match = _.filter(optionalFieldsWithOutCat, c => _.findIndex(current[el], o => o.expression === c.expression) > -1);
        temp[el] = match;
      }
    })

    return temp;
  }

  useEffect(() => {
    if (currentData.type === modalType) {
      setCurrentSelectedMetric(getSelectedFields(currentData));
    } else {
      setCurrentSelectedMetric({});
    }
  }, [modalType, currentData])

  const [inputErrorMsg, setInputErrorMsg] = useState({
    [basicConstants.FIELDS_OVERVIEW]: '',
    [basicConstants.FIELDS_CREATIVE]: '',
    [basicConstants.FIELDS_TA]: '',
    [basicConstants.LINE_FIELDS_OVERVIEW]: ''
  });

  const handleClickSubmit = () => {
    let isError = false;

    currentBlocks.forEach(el => {
      if (modalType === basicConstants.EMAIL_TEMPLATE_COVERSION_METRICS && el.name === basicConstants.FIELDS_OVERVIEW) return;

      if (!el.option) {
        if (!currentSelectedMetric[el.name] || !currentSelectedMetric[el.name].length) {
          setInputErrorMsg(prev => ({ ...prev, [el.name]: 'emailData.template.modal.selectMetrics' }));
          isError = true;
        } else {
          setInputErrorMsg(prev => ({ ...prev, [el.name]: '' }));
        }
      }
    })

    if (isError) return;

    handleSubmit(currentSelectedMetric);

    setInputErrorMsg({});
    handleCloseModal();
  }

  const handleClickCancel = () => {
    setInputErrorMsg({});
    handleCancel();
    handleCloseModal();
  }

  return (
    <>
      {
        modalType && currentTemplateType.modal &&
        <Modal
          open={modalType ? true : false}
        >
          <ModalWrapperNormal
            sx={{
              maxWidth: '600px',
            }}
          >
            <ModalHeader
              title={<FormattedMessage id={emailMediaData[media].modalTitle} />}
              handleClose={handleClickCancel}
            />

            <Box
              sx={{
                overflow: 'auto',
                maxHeight: '80vh',
                padding: '16px 40px',
              }}
            >
              {currentBlocks.map(el => {
                // FB CONVERSION_2：概況
                if (modalType === basicConstants.EMAIL_TEMPLATE_COVERSION_METRICS && el.id === 'facebook-overviewFields') {
                  return (
                    <Box key={el.id} sx={{ mb: 3 }}>
                      <CustomFormLabel>
                        <FormattedMessage id={el.title} />：<FormattedMessage id={el.content} />
                      </CustomFormLabel>
                    </Box>
                  )
                };

                // Google CONVERSION_1：概況
                if (el.id === 'google-overviewFields') {
                  return (
                    <Box key={el.id} sx={{ mb: 3 }}>
                      <Box sx={{ mb: 4 }}>
                        <CustomFormLabel>
                          <FormattedMessage id={el.title} />：<FormattedMessage id={el.content} />
                        </CustomFormLabel>
                      </Box>

                      <Box sx={{ mb: 3, color: theme.palette.google.main }}>
                        <CustomFormLabel>
                          <FormattedMessage id="emailData.template.modal.selectMetricsCampaign" />
                        </CustomFormLabel>
                      </Box>
                    </Box>
                  )
                };

                // LINE CONVERSION_1：概況
                if (el.id === 'line-overviewFields') {
                  return (
                    <Box key={el.id} sx={{ mb: 3 }}>
                      <CustomFormLabel>
                        <FormattedMessage id={el.title} />：<FormattedMessage id={el.content} />
                      </CustomFormLabel>
                    </Box>
                  )
                };

                return (
                  <Box key={el.id}>
                    {/* Google 廣告活動類型 */}
                    {el.title === "emailData.template.modal.overview" && el.category &&
                      <Typography
                        sx={{
                          ...theme.typography.h4_normal,
                          mb: 0,
                          color: theme.palette.grey.w700,
                        }}
                      >
                        <PagesOutlinedIcon sx={{ verticalAlign: 'sub' }} /> <FormattedMessage id={el.category} />
                      </Typography>
                    }
                    <Box sx={{ mb: 3 }}>
                      {/* title: 概況/素材表現/受眾表現/剩餘預算/關鍵字 */}
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <CustomFormLabel sx={{ margin: '5px 0' }}>
                          <FormattedMessage id={el.title} />
                          {!el.option && <span>*</span>}
                        </CustomFormLabel>
                      </Box>

                      {/* 選擇指標 */}
                      {el.form === 'Autocomplete' &&
                        <Autocomplete
                          multiple
                          size="small"
                          id={el.name}
                          options={optionalFieldsWithOutCat}
                          value={currentSelectedMetric[el.name] || []}
                          disableCloseOnSelect={optionalFieldsWithOutCat.length > 1 ? true : false}
                          disableClearable={true}
                          noOptionsText={<FormattedMessage id="common.search.metricNotFound" />}
                          getOptionLabel={(option) =>
                            intl.formatMessage({ id: `${formatMedia}.field.${option.expression}` })
                          }
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              <Checkbox
                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                style={{ marginRight: 8 }}
                                checked={selected}
                                sx={{
                                  padding: 0
                                }}
                              />
                              <FormattedMessage id={`${formatMedia}.field.${option.expression}`} />
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={intl.formatMessage({ id: "emailData.template.modal.selectMetrics" })}
                            />
                          )}
                          onChange={(e, newValue) => {
                            handleChangeEmailTemplateMetric(e, newValue, el.name, modalType)
                          }}
                          ChipProps={{
                            deleteIcon: <HighlightOffOutlinedIcon />
                          }}
                          popupIcon={<KeyboardArrowDownOutlinedIcon />}

                        />
                      }

                      {/* LINE */}
                      {el.form === 'Radio' &&
                        <FormControl>
                          <RadioGroup
                            row
                            value={emailRemainbudget}
                            onChange={changeRemainbudget}
                          >
                            <FormControlLabel value={true} control={<Radio />} label={<FormattedMessage id="common.label.show" />} />
                            <FormControlLabel value={false} control={<Radio />} label={<FormattedMessage id="common.label.hide" />} />
                          </RadioGroup>
                        </FormControl>
                      }
                      {el.name === basicConstants.LINE_FIELDS_CREATIVE &&
                        <Box mt={1}>
                          <Typography variant="body_sm" sx={{ color: theme.palette.line.main }}>
                            <FormattedMessage id={el.content} />
                          </Typography>
                        </Box>
                      }

                      <FormHelperText error>
                        {inputErrorMsg[el?.name] &&
                          <FormattedMessage id={inputErrorMsg[el.name]} />
                        }
                      </FormHelperText>
                    </Box>
                  </Box>
                )
              })
              }
            </Box>

            <ModalFooter
              media={media}
              checkBottonContent={<FormattedMessage id="common.button.confirm" />}
              handelCancel={handleClickCancel}
              handleSubmit={handleClickSubmit}
            />
          </ModalWrapperNormal>

        </Modal>
      }
    </>
  )
}

export default EmailTemplateModal;